import React from "react"
import logo from "../../assets/growth-engine-logo.png"
import { Image } from "react-bootstrap"

const Navigation = () => {
  return (
    <div className="navigation">
      <a href='https://www.the-growth-engine.com/'><Image src={logo} fluid={true} className="navigation__logo" /></a>
    </div>
  )
}

export default Navigation
